export default __webpack_public_path__ + "static/media/Strifescar Armbands.3628d2e8.jpg";